import React from 'react';
import styles from '../../WizardSteps.module.css';
import summaryStyles from './SummaryStep.module.css';

// Generate confetti pieces with random properties
const CONFETTI_PIECES = Array.from({ length: 24 }, (_, i) => ({
  id: i,
  left: `${Math.random() * 100}%`,
  delay: `${Math.random() * 2}s`,
  duration: `${2 + Math.random() * 2}s`,
  color: ['#2563eb', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899'][i % 6],
  size: 6 + Math.random() * 6,
}));

const SummaryStep = ({ wizardData }) => {
  const { projectInfo, floors, spaces, homeChoices } = wizardData || {};

  // Count stats
  const floorCount = floors?.floors?.length || 0;
  const spaceCount = spaces?.spaces?.length || 0;
  const choicesCount = Object.keys(homeChoices?.selections || {}).length;

  return (
    <div className={styles.stepContainer}>
      {/* Confetti animation */}
      <div className={summaryStyles.confettiContainer} aria-hidden="true">
        {CONFETTI_PIECES.map(piece => (
          <div
            key={piece.id}
            className={summaryStyles.confettiPiece}
            style={{
              left: piece.left,
              animationDelay: piece.delay,
              animationDuration: piece.duration,
              backgroundColor: piece.color,
              width: `${piece.size}px`,
              height: `${piece.size}px`,
            }}
          />
        ))}
      </div>

      {/* Header */}
      <div className={styles.header}>
        <div className={summaryStyles.successIcon}>✓</div>
        <h1 className={summaryStyles.celebrationTitle}>הפרויקט שלך מוכן!</h1>
        <p className={styles.subtitle}>
          {projectInfo?.projectName || projectInfo?.address || 'הפרויקט החדש שלך'}
        </p>
      </div>

      {/* Brief Summary */}
      <div className={summaryStyles.summaryCard}>
        <div className={summaryStyles.statRow}>
          <span className={summaryStyles.statValue}>{floorCount}</span>
          <span className={summaryStyles.statLabel}>קומות</span>
        </div>
        <div className={summaryStyles.statRow}>
          <span className={summaryStyles.statValue}>{spaceCount}</span>
          <span className={summaryStyles.statLabel}>חללים</span>
        </div>
        <div className={summaryStyles.statRow}>
          <span className={summaryStyles.statValue}>{choicesCount}</span>
          <span className={summaryStyles.statLabel}>העדפות נבחרו</span>
        </div>
      </div>

      {/* What's Next */}
      <div className={summaryStyles.nextSteps}>
        <h3 className={summaryStyles.nextStepsTitle}>מה הלאה?</h3>
        <ul className={summaryStyles.nextStepsList}>
          <li>
            <span className={summaryStyles.stepIcon}>👥</span>
            <span>הזמן שותפים לפרויקט</span>
          </li>
          <li>
            <span className={summaryStyles.stepIcon}>🏠</span>
            <span>הוסף פריטים לחללים לתקצוב מדויק יותר</span>
          </li>
          <li>
            <span className={summaryStyles.stepIcon}>💰</span>
            <span>סקור את התקציב והספקים</span>
          </li>
          <li>
            <span className={summaryStyles.stepIcon}>📋</span>
            <span>צפה בכתב הכמויות ושלח לקבלנים וספקים להצעת מחיר</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SummaryStep;
